import { todayCivil } from "./dates";

function daysBetween(a: string, b: string): number {
  return Math.round((Date.UTC(+b.slice(0, 4), +b.slice(5, 7) - 1, +b.slice(8, 10)) -
    Date.UTC(+a.slice(0, 4), +a.slice(5, 7) - 1, +a.slice(8, 10))) / 86_400_000);
}

function plural(n: number, one: string, few: string, many: string): string {
  return n === 1 ? one : n >= 2 && n <= 4 ? few : many;
}

/**
 * "před 5 měsíci", "za 3 dny", "dnes" — a civil date relative to today in
 * Prague, as the legacy due-date column printed it (moment fromNow).
 */
export function relativeCivil(civil: string, today = todayCivil()): string {
  const d = daysBetween(today, civil);
  if (d === 0) return "dnes";
  const n = Math.abs(d);
  const [count, unit] =
    n < 31 ? [n, "d"] : n < 365 ? [Math.round(n / 30.4), "m"] : [Math.round(n / 365), "y"];
  if (d > 0) {
    const word = unit === "d" ? plural(count, "den", "dny", "dní") : unit === "m" ? plural(count, "měsíc", "měsíce", "měsíců") : plural(count, "rok", "roky", "let");
    return `za ${count} ${word}`;
  }
  const word = unit === "d" ? plural(count, "dnem", "dny", "dny") : unit === "m" ? plural(count, "měsícem", "měsíci", "měsíci") : plural(count, "rokem", "lety", "lety");
  return `před ${count} ${word}`;
}
